// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"emailsConfiguration_wrapper__1QGgQ","innerContent":"emailsConfiguration_innerContent__1cYqM","emailGroup":"emailsConfiguration_emailGroup__3I8w3"};